import {green, greenButtonContained} from "../../Utils/style";
import {useParams} from "react-router-dom";
import {Box, Button, Container, FormHelperText, Grid, Typography} from "@mui/material";
import {WordPressCalculatorItem} from "./WordPressCalculatorItem";
import {useState} from "react";
import dayjs from "dayjs";
import {checkAPICallLimit, getMissingKeysFromObject, isValidatePhone, LoadingComponent} from "../../Utils/Helper";
import {WordPressQuoteContact} from "../WordPressQuote/WordPressQuoteContact";
import {NODE_ROUTE_URI} from "../../Utils/apiUrl";
import axios from "axios";
import {WordPressCalculatorResult} from "./WordPressCalculatorResult";

export const WordPressCalculator = () => {

    const {tab} = useParams();
    const {lng} = useParams();

    const [palletDetail, setPalletDetail] = useState(null);
    const [validatedResult, setValidatedResult] = useState(null);
    const [isCall, setIsCall] = useState(false);
    const [apiCheck, setAPICheck] = useState(null);
    const [contact, setContact] = useState(null);
    const [validatedEmail, setValidatedEmail] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(false);
    const [calculatedResult, setCalculatedResult] = useState(null);

    const cbHandlePalletDetail = (data) => {
        setPalletDetail(data);
    }

    const cbHandleContact = (data) => {
        setContact(data);
    }

    const cbHandleValidatedEmail = (data) => {
        setValidatedEmail(data);
    }

    const validateEmailAddress = async (email) => {
        let requestURL = `${NODE_ROUTE_URI}/validateEmail`;
        try {
            const result = await axios({
                method: 'post',
                url: requestURL,
                data: {
                    email: email,
                    validateRegex: true,
                    validateMx: true,
                    validateTypo: false,
                    validateDisposable: false,
                    validateSMTP: false
                }
            })
            console.log('[validateEmailAddress] result - ', result);
            return result?.data;
        } catch (e) {
            console.log(e.response)
        }
    }

    const calculateVolumeWeight = async () => {
        try {
            setLoading(true);
            const requestURL = `${NODE_ROUTE_URI}/shippingLTLForAdmin/calculateLTLPackageVolumeWeight`;
            const data = {
                orderType: 'LTL',
                conversionRate: 5000,
                linearRatio: palletDetail.linearRatio || 9,
                packageData: [
                    {
                        length: palletDetail?.length,
                        width: palletDetail?.width,
                        height: palletDetail?.height,
                        weight: palletDetail?.weight,
                        lengthUnit: 'in',
                        weightUnit: 'lb',
                        quantity: palletDetail?.quantity,
                    }
                ]
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })
            console.log('[calculateVolumeWeight] result', result);
            setCalculatedResult(prevState => ({
                ...prevState,
                volumeWeight: result?.data
            }))
        } catch (e) {
            console.log('[calculateVolumeWeight] error', e?.response);
        } finally {
            await calculateFreightClass();
        }
    }

    const calculateFreightClass = async () => {
        try {
            const requestURL = `${NODE_ROUTE_URI}/shippingLTLForAdmin/calculateFreightClass`;

            const data = {
                lengthInches: palletDetail?.length,
                widthInches: palletDetail?.width,
                heightInches: palletDetail?.height,
                weightLbs: palletDetail?.weight,
                userEmail: contact?.email
            }

            const result = await axios({
                method: 'post',
                url: requestURL,
                data: data
            })
            console.log('[calculateFreightClass] result', result);
            setCalculatedResult(prevState => ({
                ...prevState,
                freightClass: result?.data
            }))
        } catch (e) {
            console.log('[calculateVolumeWeight] error', e?.response);
        } finally {
            setLoading(false);
        }
    }

    const handleCalculateMap = async () => {
        switch (tab.toLowerCase()) {
            case 'ltl':
                await calculateVolumeWeight();
                break
            default:
                return true
        }
    }

    const validation = async () => {
        const missingKeys = getMissingKeysFromObject({
            ...palletDetail
        });
        const contactEmailCheck = await validateEmailAddress(contact?.email);
        cbHandleValidatedEmail(contactEmailCheck);
        const contactPhoneCheck = tab?.toLowerCase() === 'moving' ? isValidatePhone(contact?.phone) : true;

        if (missingKeys?.length > 0 ||
            !contactEmailCheck?.valid ||
            !contactPhoneCheck) {
            return false;
        } else {
            return true;
        }
    }

    const handleCalculate = async () => {
        const validationResult = await validation();
        console.log('[WordPressCalculator] handleCalculate - validationResult', validationResult);

        setValidatedResult(validationResult);
        if (validationResult) {
            const apiCheckResult = checkAPICallLimit('iframe');
            setAPICheck(apiCheckResult);
            if (apiCheckResult?.allowed) {
                await handleCalculateMap();
            }
        }
    }

    const handleCalculateAgain = () => {
        setCalculatedResult(null);
        setError(false);
        setIsCall(false);
        setContact(null);
        setValidatedEmail(null);
        setValidatedResult(null);
    }

    const handleRedirectToApp = () => {
        window.top.location.href = 'https://app.uucargo.ca/sign-in';
    }

    const redirectToApp = () => {

        return (
            <>
                <Grid size={{xs: 12, md: 6}}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Button
                            variant='contained'
                            sx={greenButtonContained}
                            onClick={handleRedirectToApp}
                        >
                            <Typography sx={{textTransform: 'none'}}>
                                {lng === 'cn' ? '登录' : "Sign In"}
                            </Typography>
                        </Button>
                    </Box>
                </Grid>
                <Grid size={{xs: 12, md: 6}}>
                    <Box sx={{
                        display: 'flex',
                        justifyContent: 'center'
                    }}>
                        <Button
                            variant='contained'
                            sx={greenButtonContained}
                            onClick={handleCalculateAgain}
                        >
                            <Typography sx={{textTransform: 'none'}}>
                                {lng === 'cn' ? '新的计算' : "New Calculation"}
                            </Typography>
                        </Button>
                    </Box>
                </Grid>
            </>
        )
    }

    if (!loading && error) {
        return (
            <Container maxWidth='xl'>
                <Box sx={{
                    display: 'flex',
                    padding: '40px 0px'
                }}>
                    <Box sx={{
                        border: `10px solid ${green}`,
                        borderRadius: '10px',
                        padding: '20px',
                        width: '100%',
                        minHeight: tab?.toLowerCase() === 'moving' ? '600px' : '350px'
                    }}>
                        <Grid container spacing={4}>
                            <Grid size={{xs: 12}}>
                                <Typography>
                                    {lng === 'cn' ? '根据您当前的选择，系统无法实时计算。' : "Based on the selections you've made, the system cannot calculate in real time."}
                                </Typography>
                            </Grid>
                            {redirectToApp()}
                        </Grid>
                    </Box>
                </Box>
            </Container>
        )
    }

    if (calculatedResult) {
        return (
            <Container maxWidth='xl'>
                <Box sx={{
                    display: 'flex',
                    padding: '40px 0px'
                }}>
                    <Box sx={{
                        border: `10px solid ${green}`,
                        borderRadius: '10px',
                        padding: '20px',
                        width: '100%',
                        minHeight: tab?.toLowerCase() === 'moving' ? '600px' : '350px'
                    }}>
                        <Grid container spacing={4}>
                            <WordPressCalculatorResult
                                tab={tab}
                                lng={lng}
                                redirectToApp={redirectToApp}
                                palletDetail={palletDetail}
                                calculatedResult={calculatedResult}
                            />
                        </Grid>
                    </Box>
                </Box>
            </Container>
        )
    }

    // console.log('[WordPressCalculator] palletDetail', palletDetail);

    return (
        <Container maxWidth='xl'>
            <Box sx={{
                display: 'flex',
                padding: '40px 0px'
            }}>
                <Box sx={{
                    border: `10px solid ${green}`,
                    borderRadius: '10px',
                    padding: '20px',
                    width: '100%',
                    minHeight: tab?.toLowerCase() === 'moving' ? '600px' : '350px'
                }}>
                    <Grid container spacing={4}>
                        <WordPressCalculatorItem
                            tab={tab}
                            lng={lng}
                            validatedResult={validatedResult}
                            cbHandlePalletDetail={cbHandlePalletDetail}/>
                        <WordPressQuoteContact tab={tab} cbHandleContact={cbHandleContact}
                                               validatedResult={validatedResult}
                                               validatedEmail={validatedEmail}
                                               lng={lng}/>
                        <Grid size={{xs: 12}}>
                            <Box sx={{
                                display: 'flex',
                                justifyContent: 'center',
                                flexDirection: 'column',
                                alignItems: 'center'
                            }}>
                                <Button
                                    variant='contained'
                                    sx={greenButtonContained}
                                    // size='small'
                                    // loading={loading}
                                    onClick={handleCalculate}
                                    disabled={isCall}
                                >
                                    <Typography sx={{textTransform: 'none'}}>
                                        {lng === 'cn' ? '计算' : "Calculate"}
                                    </Typography>
                                </Button>
                                {
                                    (!apiCheck?.allowed && apiCheck !== null) &&
                                    <FormHelperText sx={{color: 'error.main'}}>
                                        {lng === 'cn' ? `10分钟内仅允许10次免费计算，请于 ${dayjs(apiCheck?.nextAvailable).format('h:mm:ss a')} 后再试。` : `Maximum 10 free calculates per 10 minutes. Try again at ${dayjs(apiCheck?.nextAvailable).format('h:mm:ss a')}.`}
                                    </FormHelperText>
                                }
                            </Box>
                        </Grid>
                    </Grid>
                </Box>
            </Box>
            <LoadingComponent loading={loading} message={lng === 'cn' ? "正在计算" : "Calculating..."}/>
        </Container>
    )
}
